import { create } from "zustand";

export const FabricadosStore = create((set) => ({
  fabricadosMapImage: null,
  produtosFabricadosImage: null,

  setFabricadosMapImage: (img) => set({ fabricadosMapImage: img }),
  setProdutosFabricadosImage: (img) => set({ produtosFabricadosImage: img}),
}));
